var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Search from '@olxbr/olx-icons/dist/System/Search';
import { Link } from '@olxbr/ds-web';
import { getFriendlyUrl } from '../utils/suggestionUrlFormatter';
var HOME_ICON_SIZE = 22;
var LISTING_HEADER_ICON_SIZE = 18;
var Wrappper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n\n  &:hover {\n    background: var(--color-neutral-light);\n  }\n"])));

var OraculoCategoryItem = function OraculoCategoryItem(_ref) {
  var _query;

  var query = _ref.query,
      boldSugg = _ref.boldSugg,
      suggestion = _ref.suggestion,
      homeStyle = _ref.homeStyle,
      indexPosition = _ref.indexPosition,
      categoryIdFilter = _ref.categoryIdFilter,
      _onClick = _ref.onClick;
  var suggestionQuery = suggestion === null || suggestion === void 0 ? void 0 : suggestion.query;
  var categoryId = suggestion === null || suggestion === void 0 ? void 0 : suggestion.category_id;
  var iconSize = homeStyle ? HOME_ICON_SIZE : LISTING_HEADER_ICON_SIZE;
  query = (_query = query) === null || _query === void 0 ? void 0 : _query.toLowerCase();
  return /*#__PURE__*/React.createElement(Wrappper, null, /*#__PURE__*/React.createElement(Link, {
    href: getFriendlyUrl(suggestionQuery, categoryId),
    className: "listing-suggestion-item",
    onClick: function onClick(event) {
      return _onClick(event, {
        suggestion: suggestion,
        suggestionIndex: indexPosition,
        submitMethod: 'enter'
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "listing-suggestion-item__icon"
  }, /*#__PURE__*/React.createElement(Search, {
    size: iconSize
  })), /*#__PURE__*/React.createElement("div", {
    className: "listing-suggestion-item__text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "suggestion-query"
  }, query, /*#__PURE__*/React.createElement("b", null, boldSugg)), !categoryIdFilter && /*#__PURE__*/React.createElement("div", {
    className: "suggestion-category"
  }, /*#__PURE__*/React.createElement("div", {
    className: "suggestion-category__prefix"
  }, "em"), /*#__PURE__*/React.createElement("div", {
    className: "suggestion-category__name"
  }, suggestion.category)))));
};

OraculoCategoryItem.propTypes = process.env.NODE_ENV !== "production" ? {
  query: PropTypes.string,
  boldSugg: PropTypes.string,
  suggestion: PropTypes.shape({
    category: PropTypes.string,
    category_id: PropTypes.number,
    query: PropTypes.string
  }),
  homeStyle: PropTypes.bool,
  indexPosition: PropTypes.number,
  categoryIdFilter: PropTypes.string,
  onClick: PropTypes.func
} : {};
export default OraculoCategoryItem;